<script>
export default {
  name: 'RtDescriptionsItem',
  props: {
    label: {
      type: String,
      default: ''
    },
    span: {
      type: Number,
      default: 1
    },
    contentClassName: {
      type: String,
      default: ''
    },
    contentStyle: {
      type: Object
    },
    labelClassName: {
      type: String,
      default: ''
    },
    labelStyle: {
      type: Object
    }
  },
  render () {
    return null;
  }
};
</script>



// WEBPACK FOOTER //
// rtDescriptionsItem.vue?5e1b3cca